module.exports = __webpack_public_path__ + "img/bullseye.82d31b27.svg";